'use client'
import { Table, TableRow, TableHeader, TableCell, ColorButton, ConfirmMessage } from "@/components/ui";
import { deleteClientAccountant, getClientAccountant } from "@/app/api";
import { clientAccountantResponseType, defaultClientAccountant } from "@/types";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export function DeleteClientAccountant({ id }: { id: string }) {
    const router = useRouter();
    const [loading, setLoading] = useState<boolean>(false)
    const [openMessage, setOpenMessage] = useState<boolean>(false)
    const [clientAccountantData, setClientAccountantData] = useState<clientAccountantResponseType>()

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await getClientAccountant(id)
                if (response !== undefined) {
                    setClientAccountantData(response)
                }
            } catch (e) {
                console.log('Não foi possível buscar o usuário: ', e)
            }
        }

        fetchUser()
    }, [id]);

    const clientAccountant = clientAccountantData || defaultClientAccountant

    const handleDeleteClientAccountant = async () => {
        setLoading(true)
        try {
            const res = await deleteClientAccountant(id)
            if (res) {
                router.back()
            }
        } catch (err) {
            console.log("Erro ao excluir retorno: ", err);
        } finally {
            setLoading(false);
        }
    }



    return (
        <div>
            <div className="hidden md:flex">
                <Table>
                    <thead>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableHeader>Empresa</TableHeader>
                            <TableHeader>Nome</TableHeader>
                            <TableHeader>Status</TableHeader>
                            <TableHeader>Data do Cadastro</TableHeader>
                            <TableHeader>Data da Atualização</TableHeader>
                        </TableRow>
                    </thead>
                    <tbody>
                        <TableRow>
                            <TableCell>{clientAccountant.client.code}</TableCell>
                            <TableCell>{clientAccountant.client.userName}</TableCell>
                            <TableCell>{clientAccountant.client.name}</TableCell>
                            <TableCell>
                                {clientAccountant.client.role === 'CLIENT' ? 'Ativo'
                                    : clientAccountant.client.role === 'INACTIVE' ? 'Inativo'
                                        : clientAccountant.client.role === 'CANCELED' ? 'Cancelado'
                                            : '- - - - -'
                                }
                            </TableCell>
                            <TableCell>{new Date(clientAccountant.createdAt).toLocaleDateString()}</TableCell>
                            {clientAccountant.updatedAt === clientAccountant.createdAt
                                ?
                                <TableCell> {"- - - - -"} </TableCell>
                                :
                                <TableCell>{new Date(clientAccountant.updatedAt).toLocaleDateString()}</TableCell>
                            }
                        </TableRow>
                        <TableRow>
                            <TableHeader colSpan={2}>Observação</TableHeader>
                            <TableCell colSpan={3}>{clientAccountant.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>

            <div className="flex md:hidden">
                <Table>
                    <tbody>
                        <TableRow>
                            <TableHeader>Código</TableHeader>
                            <TableCell>{clientAccountant.client.code}</TableCell>
                            <TableHeader>Empresa</TableHeader>
                            <TableCell>{clientAccountant.client.userName}</TableCell>
                            <TableHeader>Nome</TableHeader>
                            <TableCell>{clientAccountant.client.name}</TableCell>
                            <TableHeader>Status</TableHeader>
                            <TableCell>
                                {clientAccountant.client.role === 'CLIENT' ? 'Ativo'
                                    : clientAccountant.client.role === 'INACTIVE' ? 'Inativo'
                                        : clientAccountant.client.role === 'CANCELED' ? 'Cancelado'
                                            : '- - - - -'
                                }
                            </TableCell>
                            <TableHeader>Data do Cadastro</TableHeader>
                            <TableCell>{new Date(clientAccountant.createdAt).toLocaleDateString()}</TableCell>
                            <TableHeader>Data da Atualização</TableHeader>
                            {clientAccountant.updatedAt === clientAccountant.createdAt
                                ?
                                <TableCell> {"- - - - -"} </TableCell>
                                :
                                <TableCell>{new Date(clientAccountant.updatedAt).toLocaleDateString()}</TableCell>
                            }
                            <TableHeader>Observação</TableHeader>
                            <TableCell>{clientAccountant.observation}</TableCell>
                        </TableRow>
                    </tbody>
                </Table>
            </div>


            <div className="flex flex-col gap-3 p-4  items-center justify-center">
                <ColorButton disabled={loading} onClick={() => setOpenMessage(true)}>
                    {loading ? 'Excluindo...' : 'Excluir'}
                </ColorButton>
            </div>

            <ConfirmMessage
                isOpen={openMessage}
                title="Confirmar exclusão"
                message="Tem certeza que deseja excluir a relação desse cliente com o contador? Essa ação não poderá ser desfeita."
                onConfirm={handleDeleteClientAccountant}
                onCancel={() => setOpenMessage(false)}
            />
        </div >
    )
}